// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-indicator {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  vertical-align: middle;
}

.order-indicator-up {
  color: #2e7d32;
}

.order-indicator-down {
  color: #e65100;
}

.order-indicator-placeholder {
  display: inline-block;
  width: 18px;
  height: 18px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
